import { img4, img5, img6, img7, img8, img9, img10 } from '../assets/images';

export const blogPosts = [
  {
    slug: "7-essential-parenting-tips-for-your-preschooler",
    title: "7 Essential Parenting Tips for Your Preschooler",
    category: "Parenting Tips",
    date: "February 10, 2026",
    author: "Mrs. Anita Das",
    readTime: "5 Min Read",
    excerpt: "Our expert educators share 7 proven tips to support your child's growth at home and strengthen the parent-school partnership.",
    image: img4,
    featured: true,
    tips: [
      "Maintain daily routines",
      "Encourage independence",
      "Read together daily",
      "Limit screen time",
      "Promote communication",
      "Use positive discipline",
      "Stay involved in school life"
    ]
  },
  {
    slug: "magic-of-play-based-learning-early-childhood",
    title: "The Magic of Play-Based Learning in Early Childhood",
    category: "Child Development",
    date: "January 28, 2026",
    author: "Mrs. Priya Mohapatra",
    readTime: "4 Min Read",
    excerpt: "Research shows children learn best through play. Discover how Happykidz Preschool integrates purposeful play into every lesson of the day.",
    image: img5
  },
  {
    slug: "annual-sports-day-2026-joy-and-achievement",
    title: "Annual Sports Day 2026 — A Day of Joy and Achievement",
    category: "Events",
    date: "January 15, 2026",
    author: "Happykidz Team",
    readTime: "3 Min Read",
    excerpt: "Our Annual Sports Day was a tremendous success! Here are the highlights from a day filled with excitement, teamwork, and proud parental moments.",
    image: img6
  },
  {
    slug: "how-to-prepare-your-child-first-day-school",
    title: "How to Prepare Your Child for Their First Day of School",
    category: "School Readiness",
    date: "December 20, 2025",
    author: "Ms. Kavita Sharma",
    readTime: "4 Min Read",
    excerpt: "Starting preschool is a big milestone. We share top tips to help parents and children navigate this exciting transition with confidence.",
    image: img7
  },
  {
    slug: "art-therapy-building-emotional-intelligence",
    title: "Art Therapy: Building Emotional Intelligence in Children",
    category: "Activities",
    date: "December 05, 2025",
    author: "Ms. Deepa Rath",
    readTime: "3 Min Read",
    excerpt: "Creative art activities help children process emotions, build confidence, and develop self-expression skills that last a lifetime.",
    image: img8
  },
  {
    slug: "admissions-open-academic-year-2026-27",
    title: "Admissions Open for Academic Year 2026–27",
    category: "School Updates",
    date: "November 20, 2025",
    author: "Happykidz Team",
    readTime: "2 Min Read",
    excerpt: "We're excited to announce that admissions are now open for the new academic year. Limited seats available across all programs!",
    image: img9
  },
  {
    slug: "summer-camp-2026-register-now",
    title: "Summer Camp 2026: Register Now for Exciting Programs",
    category: "Events",
    date: "November 10, 2025",
    author: "Happykidz Team",
    readTime: "3 Min Read",
    excerpt: "Get ready for an unforgettable summer! Nature Camp, STEAM, Music, Sports, Cooking and Arts & Crafts camps are now open for registration.",
    image: img10
  }
];

export const parentingTips = [
  { tip: "Maintain daily routines", desc: "Consistent morning and bedtime routines give children a sense of security and prepare them for school." },
  { tip: "Encourage independence", desc: "Allow children to do age-appropriate tasks on their own to build confidence and problem-solving skills." },
  { tip: "Read together daily", desc: "Even 15 minutes of reading each day dramatically improves vocabulary, comprehension, and imagination." },
  { tip: "Limit screen time", desc: "Balance digital activities with creative play, outdoor activities, and face-to-face interaction." },
  { tip: "Promote communication", desc: "Ask open-ended questions about their day, feelings, and ideas to build strong language skills." },
  { tip: "Use positive discipline", desc: "Guide behavior with calm, consistent boundaries rather than punishment. Praise good choices." },
  { tip: "Stay involved in school life", desc: "Attend school events, meet teachers regularly, and show genuine interest in what your child is learning." }
];
